import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteShipment, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* deleteShipmentSaga(action: DeleteShipment) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(deleteShipment, action.payload.shipmentId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.removeShipment(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteShipment() {
  yield takeEvery(LogisticsActionKeys.DELETE_SHIPMENT, deleteShipmentSaga);
}

export async function deleteShipment(
  shipmentId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<{ loadNumber: string; shipmentIds: number[] }>>> {
  return executeApiRequest(() => httpService.delete(ApiUrls.shipment(shipmentId)));
}
